export const FETCH_MY_UPCOMING_TASK_LISTING_REQUEST = 'FETCH_MY_UPCOMING_TASK_LISTING_REQUEST'
export const FETCH_MY_UPCOMING_TASK_LISTING_SUCCESS = 'FETCH_MY_UPCOMING_TASK_LISTING_SUCCESS'
export const FETCH_MY_UPCOMING_TASK_LISTING_FALUIRE = 'FETCH_MY_UPCOMING_TASK_LISTING_FALUIRE'
export const FETCH_MY_UPCOMING_TASK_MINUS_ONE_LISTING_FALUIRE = 'FETCH_MY_UPCOMING_TASK_MINUS_ONE_LISTING_FALUIRE'
export const FETCH_SEARCH_M_U_TASK='FETCH_SEARCH_M_U_TASK'